export const PIPELINE_REPORT = {
  headline: '3 deals slipped · $184k at risk',
  status: 'attention',
  durationSec: 52,
  body: `**$1.42M open across 23 deals. 3 slipped their close date ($184k), 2 moved forward, 4 have gone quiet.**

### Slipped

| Deal | Owner | Amount | Slipped by |
|---|---|---|---|
| Helios Health — Analytics platform | Rhea Kapoor | $96,000 | 31 days |
| Orbit Foods — Expansion | Kabir Shah | $54,000 | 42 days |
| Lumen Energy — Pilot | Rhea Kapoor | $34,000 | 23 days |

### Moved forward

- **Northwind Logistics** → Proposal ($120,000) — pricing call booked for Thursday.
- **Kestrel Bank** → Closed Won ($210,000, two-year renewal).

### Quiet for 14+ days

- **Globex Retail** ($78,000) — waiting on their security review.
- Umbrella Insurance ($45,000), Pinnacle Media ($28,000), Vertex Labs ($19,000).

**Suggested:** ask Rhea for a recovery plan on Helios before Friday’s forecast call.

Posted to #sales.`,
}
